import React from 'react';
import { ComparisonStatus } from '../../types/apiDiff';
import './CompareVersions.css';

interface StatusBadgeProps {
    status: ComparisonStatus;
}

const STATUS_LABELS: Record<ComparisonStatus, string> = {
    added: 'Added',
    changed: 'Changed',
    deprecated: 'Deprecated',
    removed: 'Removed',
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
    <span className={`compare-status-badge compare-status-${status}`}>{STATUS_LABELS[status]}</span>
);

export default StatusBadge;
